import { YieldFetcher } from '../../types'

/**
 * Hastra Democratized PRIME yield, from the public Proof-of-Reserve feed.
 *
 * PRIME (`0x19ebb352…`) is an ERC-4626 vault over wYLDS (itself ERC-4626 over
 * USDC). Its share/asset ratio accrues on-chain (`convertToAssets`), but the
 * realized strategy APR is published off-chain via the PoR `demo_prime_card`:
 *   - `current_rate` — current annualized rate, in **percent** (e.g. `6.02`)
 *   - `fee`          — management fee, in **percent** (e.g. `0.5`)
 *   - `lifetime_average_rate` — net lifetime average, as a **fraction**
 *     (e.g. `0.0764` ⇒ 7.64%)
 *
 * We surface the current rate net of fee, falling back to the lifetime average
 * when the current rate is unavailable. Value is an APR percent, matching what
 * the savings provider expects as `supplyRate`.
 */
const HASTRA_POR_URL = 'https://www.hastra.io/hastra-pulse/public/api/v1/por'

/** Matches PRIME's `assetGroup` tag and the savings-registry `yieldKey`. */
export const HASTRA_PRIME_KEY = 'Hastra PRIME::PRIME'

export const hastraPrimeFetcher: YieldFetcher = {
  label: 'Hastra',
  fetch: async () => {
    const res = await fetch(HASTRA_POR_URL, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    }).then((r) => r.json())

    const card = (res as any)?.demo_prime_card ?? {}
    const current = Number(card.current_rate)
    const fee = Number(card.fee)
    const lifetimePct = Number(card.lifetime_average_rate) * 100

    let apr: number
    if (Number.isFinite(current)) {
      apr = current - (Number.isFinite(fee) ? fee : 0)
    } else if (Number.isFinite(lifetimePct)) {
      apr = lifetimePct
    } else {
      apr = 0
    }

    return { [HASTRA_PRIME_KEY]: Math.max(0, apr) }
  },
}
